import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-center px-4 py-24 text-center md:px-8 md:py-32">
        <p className="font-heading text-[80px] font-bold leading-none text-primary-900 md:text-[120px]">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
          这个页面不存在
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的地址可能已经调整或输入有误。可以返回首页继续浏览精选内容，或者用搜索找找想看的片目。
        </p>
        <p className="mt-2 break-all text-xs text-foreground-700">{location.pathname}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-home-4-line text-sm" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-200 transition-colors hover:border-primary-600 hover:text-primary-200"
          >
            <i className="ri-search-line text-sm" />
            去搜索
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}